import { BatchExecutor } from '@fortem-monorepo/web-sdk'

export const FUNDS = ['FCAGF', 'FCDGF', 'FCPGF', 'LOWES'] as const
export type Fund = (typeof FUNDS)[number]

export const INPUT_TYPES = {
  ALL_JOBS: 'all_jobs',
  CUSTOM_STRATEGIES: 'custom_strategies',
  VOLDIV_ADJUSTMENTS: 'vol_div_adjustments',
  CALIBRATION: 'calibration',
  DEFAULT_RISK: 'default_risk',
  CUSTOM_RISK: 'custom_risk',
  DERIVED_METRICS: 'derived_metrics',
} as const

export type InputType = (typeof INPUT_TYPES)[keyof typeof INPUT_TYPES]

export const INSTANCE_TAGS = [
  'LOCALINST1',
  'LOCALINST2',
  'AWS_INSTANCE_X',
] satisfies BatchExecutor.InstanceTag[]

export const CONFIGS = ['fast', 'medium', 'strict'] satisfies BatchExecutor.Config[]

export const REPORT_TYPES = [
  'risk',
  'var',
  'attributions',
  'mtm',
] satisfies BatchExecutor.ReportType[]
